module.exports = __webpack_public_path__ + "img/hx_8.39c06ab7.png";